// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/timeline"
import { TIMESHEET_FIELD_VIEW_MODE } from "."
import { ofType } from "redux-observable"

export type StorageReader = () => Observable<number>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(TIMESHEET_FIELD_VIEW_MODE)
    if (data !== null) {
      return of(Number(data))
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadTimesheetFieldViewMode = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      ofType(Actions.loadTimesheetFieldViewModeFromStorage),
      mergeMap(_ => load().pipe(
        map(Slice.setTimesheetFieldViewMode),
        catchError(_ => of(Actions.loadTimesheetFieldViewModeFromStorageFailed())),
      )),
    )

export default loadTimesheetFieldViewMode(load)
